// libs.
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';

// selector.
import { getSelectedDocument } from '@domains/documents-review/store/slices/document-review-slice';

// components.
import { FileViewer } from './FileViewer';
import { DocumentsTabs } from './DocumentsTabs';

// styles.
import { WrapperModal } from '@domains/polygon-tool/components/styles';

interface ModalViewerProps {
  show: boolean;
  onClose: () => void;
}

export const ModalViewer = ({ show, onClose }: ModalViewerProps) => {
  const selectedDocument = useSelector(getSelectedDocument);

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      dialogClassName="modal-90w"
      centered
    >
      <WrapperModal>
        <Modal.Body
          style={{ height: '80vh' }}
          className="d-flex flex-column p-0"
        >
          <DocumentsTabs isInModal />
          <div className="flex-grow-1 overflow-hidden">
            {selectedDocument ? (
              <FileViewer fileUrl={selectedDocument} />
            ) : (
              <p>Selecciona un documento para visualizarlo</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="p-0">
          <Button className="btn-habi w-30" onClick={onClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </WrapperModal>
    </Modal>
  );
};
